// extracted by mini-css-extract-plugin
export default {"header":"Experiment_header__vIZlh","count":"Experiment_count__v9TpW","btn":"Experiment_btn__Q5x3+"};